export const kozhakhmetova = {
    id: "kozhakhmetova",
    name: { ru: "Кожахметова Жанна Ербулатовна", kz: "Қожахметова Жанна Ерболатқызы" },
    position: { ru: "Психолог, специалист по спортивной и социальной психологии", kz: "Психолог, спорт және әлеуметтік психология маманы" },
    department: "sportmed",
    image: "/team_photoes/new/Жанна Ерболатқызы.svg",
    experience: {
      ru: "С 2019 года",
      kz: "2019 жылдан бері"
    },
    education: {
      ru: `2019–2022 — Омская гуманитарная академия
Магистр социальной психологии

2024–2025 — Московский институт технологий и управления
Переподготовка по направлению спортивная психология`,
      kz: `2019–2022 — Омбы гуманитарлық академиясы
Әлеуметтік психология магистрі

2024–2025 — Мәскеу технологиялар және басқару институты
Спорт психологиясы бойынша қайта даярлау`
    },
    specialization: {
      ru: `Психологическое сопровождение спортсменов
Работа с мотивацией, тревожностью, восстановлением после травм
Поддержка подростков и командная работа в спорте
Владение техниками саморегуляции и стресс-менеджмента`,
      kz: `Спортшыларды психологиялық қамтамасыз ету
Мотивациямен, мазасыздықпен, жарақаттан кейінгі қалпына келтірумен жұмыс
Жасөспірімдерді қолдау және спорттағы командалық жұмыс
Өзін-өзі реттеу және стресс-менеджмент техникаларын меңгеру`
    },
    certificates: {
      ru: `• 2019 — Научная публикация: «Актуальные проблемы современной педагогики, психологии и социальной работы», г. Омск
• 2020 — Сертификат «Практический психолог»
• 2025 — "100 техник когнитивно-поведенческой терапии по работе с дисфункциональными эмоциями"
• 2025 — курс повышения квалификации "Управление агрессивным поведением в спорте"
• 2025 — Повышение квалификации курс "Когнитивно - поведенческой терапии" 211 часов         
• 2026 — Повышение квалификации курс "Эмоциональный интеллект" 30 часов`,
      kz: `• 2019 — Ғылыми жарияланым: «Қазіргі заманғы педагогика, психология және әлеуметтік жұмыстың өзекті мәселелері», Омск қ.
• 2020 — «Тәжірибелік психолог» сертификаты
• 2025 — "Дисфункционалды эмоциялармен жұмыс істеуге арналған когнитивті-мінез-құлық терапиясының 100 техникасы"
• 2025 — біліктілікті арттыру курсы "Спорттағы агрессивті мінез-құлықты басқару"
• 2026 — «Когнитивті-мінез-құлық терапиясы» біліктілікті арттыру курсы (211 сағат)
• 2026 — «Эмоциялық интеллект» біліктілікті арттыру курсы (30 сағат)`
    }
  };
